export enum ListCountEstimateMode {
  Exact = 'Exact',
  Estimated = 'Estimated',
}

export interface PaginationSummary {
  total: number;
  status: ListCountEstimateMode;
}
